import type { FC, SVGProps } from 'react';

export const MATERIAL_ICON_VIEWBOX = '0 -960 960 960' as const;

export type IconSvgComponent = FC<SVGProps<SVGSVGElement>>;

export type MaterialIconEntry = {
  type: 'material';
  base: IconSvgComponent;
  filled?: IconSvgComponent;
  viewBox: string;
  preserveColors: false;
  description?: string;
};

export type CustomIconEntry = {
  type: 'custom';
  component: IconSvgComponent;
  filled?: IconSvgComponent;
  viewBox: string;
  preserveColors: true;
  description?: string;
};

export type IconEntry = MaterialIconEntry | CustomIconEntry;
